const dataGridTextColor = 'var(--mui-palette-common-onBackground)';
const dataGridBorderColor = 'rgba(var(--mui-palette-common-onBackgroundChannel) / 0.18)';
const dataGridFontSize = '13px';
const getDataGridHeaderBackground = (theme) => theme.vars.palette.background.default;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  defaultProps: {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  },
  styleOverrides: {
    root: {
      borderColor: dataGridBorderColor,
      color: dataGridTextColor,
      fontSize: dataGridFontSize,
      '& .MuiDataGrid-withBorderColor': {
        borderColor: dataGridBorderColor,
      },
    },
    cell: {
      color: dataGridTextColor,
    },
    columnHeaders: ({ theme }) => ({
      backgroundColor: getDataGridHeaderBackground(theme),
    }),
    columnHeader: ({ theme }) => ({
      backgroundColor: getDataGridHeaderBackground(theme),
      color: dataGridTextColor,
    }),
    columnHeaderTitle: {
      color: dataGridTextColor,
      fontWeight: 600,
    },
    footerContainer: {
      color: dataGridTextColor,
    },
    toolbarContainer: {
      '& .MuiButton-root': {
        color: dataGridTextColor,
      },
    },
  },
};
